import { ON_PREMISE_INSTANCES } from '$app-web/constants';
import { getACTMaternityStudyId, getEnvironmentName } from '$app-web/utils';

export const getIsACT = (): boolean => getEnvironmentName() === ON_PREMISE_INSTANCES.ACT;

export const getIsCBR = (): boolean => getEnvironmentName() === ON_PREMISE_INSTANCES.CBR;

export const getIsACTMaternityStudy = (studyId: string | number): boolean =>
    getIsACT() && Number(studyId) === Number(getACTMaternityStudyId());
